import { ConfigurationPageContent } from '@enter/core';
import React from 'react';
import providerWorkerStore from 'stores/worker.store';

export const Configuration: React.FC = () => <ConfigurationPageContent store={providerWorkerStore} />;
